import React from 'react';
import i18next from 'i18next';
import { KeyboardArrowLeft } from '@mui/icons-material';
import Typography from '@mui/material/Typography';
import { Grid } from '@mui/material';

import Nothing from '../Icons/svg/nothing.svg';
import { customername } from '../../../index';

export const ErrorFallback  = () => {
  return    <Grid container alignItems="center" justifyContent="center">
    <Grid item xs={6} style={{ marginTop: '10%' }}>
      <Typography variant={'h1'}><>{i18next.t('err:occurred')}</></Typography>
      <Typography variant={'h2'}><>{i18next.t('err:errorMessage')}</></Typography>
      <br/>
      <Grid container alignItems={'center'}>
        <Grid item xs={6}>
          <Grid container alignItems="center" justifyContent="center">
            <KeyboardArrowLeft/>
            <Typography component={'a'} variant={'button'} href={'/' + customername + 'dashboard'}>
              <>{i18next.t('err:actions.backToDashboard')}</>
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={6}>
          <Grid container alignItems="center" justifyContent="center">
            <img alt={'error-image'} src={Nothing} width={'50%'} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  </Grid>;
};